import * as FIELDS from 'modules/campaigns/modules/campaigns-reports/config/fields';
import { REPORT_PRESET } from 'modules/campaigns/modules/campaigns-reports/config/pickers';
import { MODULE_NAME as SCHEDULED_REPORTS } from 'modules/scheduled-reports/config/routes';
import { availableColumnDefinitions } from './columnDefinitions';
import { defaultColumns, customColumns } from './reportPresets';
import { SCHEDULED_REPORTS_REPORT_ID } from './scheduledReportsReportId';

export const scheduledReportsReportConfig = {
    id: SCHEDULED_REPORTS_REPORT_ID,
    label: 'Reports',
    module: SCHEDULED_REPORTS,
    endpoint: 'scheduled-reports',
    rowIdField: FIELDS.SCHEDULED_REPORTS_ID.field,
    columnsDef: availableColumnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    disableExport: true,
    disableForceFetch: true,
    autoFitColumnsToScreen: true,
};
